import * as React from 'react';
import YouTube from 'react-youtube';
import CloseIcon from '../../../assets/images/icons/svg/close.svg';
import { useTranslations } from '../../../common/translation';
import { Button } from '../../../components/button/Button';
import translations from '../translations';
import { TourFeatureVideoProps } from './TourFeatureVideo.props';
import {
  FeatureVideoButtonContainer,
  FeatureVideoCloseButton,
  FeatureVideoContainer,
  FeatureVideoText,
} from './TourFeatureVideo.styles';

const youtubeOpts: any = {
  height: '100%',
  width: '100%',
  host: 'https://www.youtube-nocookie.com',
  playerVars: {
    autoplay: 1,
    color: 'red',
    enablejsapi: 1,
    modestbranding: 1,
    rel: 0,
    start: 0,
  },
};

export const TourFeatureVideo = ({
  first,
  onClose,
  onReady,
  ticketsHref,
  title,
  videoId,
  websiteHref,
}: TourFeatureVideoProps) => {
  const { t } = useTranslations(translations);

  return (
    <FeatureVideoContainer first={first}>
      <FeatureVideoCloseButton data-testid='tour-feature-video-close' onClick={onClose}>
        <CloseIcon />
      </FeatureVideoCloseButton>
      <FeatureVideoText>{title}</FeatureVideoText>
      <FeatureVideoButtonContainer>
        <Button disableCaps={true} href={ticketsHref} invertColors={true} target='_blank'>
          {t('getTicketsText', 'Get Tickets')}
        </Button>
        <Button disableCaps={true} href={websiteHref} invertColors={true} target='_blank'>
          {t('visitWebsiteText', 'Visit Website')}
        </Button>
      </FeatureVideoButtonContainer>
      <YouTube
        className='youtube-iframe'
        containerClassName='youtube-container'
        videoId={videoId}
        opts={youtubeOpts}
        onReady={onReady}
      />
    </FeatureVideoContainer>
  );
};
